import PropTypes from "prop-types";
import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import ReadOnlyField from "components/Shared/ReadOnlyField";
import logo from "static/images/logo.png";
import AppInsightsTracker from "components/Shared/AppInsightsTracker";
import {MSpinner} from "components/Shared";

class WaiverDetails extends AppInsightsTracker {
  constructor(props, context) {
    super(props, context);
    this.displayName = "WaiverDetails";
    this.showActionDialog = this.showActionDialog.bind(this);
    this.hideActionDialog = this.hideActionDialog.bind(this);
    this.isVisible = this.isVisible.bind(this);
    this.confirmHandler = this.confirmHandler.bind(this);

    this.submitHandler = this.submitHandler.bind(this);
    this.onEligibleChanged = this.onEligibleChanged.bind(this);
    this.state = {
      eligible: "",
      showThankyou: false,
      actionDialogVisible: false
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.waiver) {
      this.setState({ showThankyou: nextProps.waiver.message === "" });
    }
  }

  isVisible() {
    return this.state.actionDialogVisible;
  }
  showActionDialog() {
    this.setState({ actionDialogVisible: true });
  }

  hideActionDialog() {
    this.setState({ actionDialogVisible: false });
  }

  onEligibleChanged(val) {
    this.setState({ eligible: val });
  }

  submitHandler() {
    this.showActionDialog();
  }

  confirmHandler() {
    const dto = {
      controlIdNumber: this.props.waiver.controlIdNumber,
      eligible: this.state.eligible === "1"
    };
    this.props.onDecisionClick(dto);
    setTimeout(() => { this.hideActionDialog(); }, 1000);
  }

  render() {
    const { isFetching, waiver } = this.props;
    if (isFetching) {
      return <MSpinner/>;
    }

    const methods = [];
    methods.push(<Button variant="text" color="secondary" onClick={this.hideActionDialog}>Cancel</Button>);
    methods.push(<Button onClick={this.confirmHandler}>OK</Button>);

    const hasError = waiver.errorCode !== 0;

    return (
      <div id="waiver-decision" className="md-grid md-cell waiver-wrapper">
        <div className="waiver-form">
          <img src={logo} alt="logo.png" className="mueller-logo" />
          <h3 className="mueller-title" data-test="title">Value Verify Result</h3>

          {hasError
            ?
            <div>
              <div className="waiver-error">
                There was an error processing the request.
              </div>
              <br />
              <div>If you have any questions regarding this order please contact Mueller Customer Service at customerservice@muellerreports.com.</div>
            </div>
            :
            <div>
              <ReadOnlyField title="Address" fieldValue={waiver.address} />
              <ReadOnlyField title="Loan Number" fieldValue={waiver.loanNumber} />
              <ReadOnlyField title="DU Casefile ID" fieldValue={waiver.duNumber ? waiver.duNumber : "N/A"} />
              <br />

              {waiver.handled
                ? <div className="waiver-handled">
                  <div>{waiver.successMessage}</div>
                  <br />
                  <div>If you have any questions regarding this order please contact Mueller Customer Service at customerservice@muellerreports.com.</div>
                </div>
                : <div>
                  <FormControl>
                    <FormLabel id="selection-control-group-eligible-label">Elect the Value Verify result.</FormLabel>
                    <RadioGroup
                      aria-labelledby="selection-control-group-eligible-label"
                      name="radio-eligible"
                      value={this.state.eligible}
                      onChange={(e) => this.onEligibleChanged(e.target.value)}
                    >
                      <FormControlLabel value="1" control={<Radio />} label={waiver.eligibleText} />
                      <FormControlLabel value="0" control={<Radio />} label={waiver.ineligibleText} />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={this.submitHandler}
                    type="submit"
                    className="full-width m-t-10"
                    disabled={this.state.eligible === ""}
                  >
                    SUBMIT
                  </Button>
                </div>
              }

              <Dialog
                open={this.isVisible()}
                onClose={this.hideActionDialog}
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle>Confirm Value Verify result</DialogTitle>
                <DialogContent>
                  <p>Are your sure you want to continue?</p>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.hideActionDialog}>Cancel</Button>
                  <Button onClick={this.confirmHandler}>OK</Button>
                </DialogActions>
              </Dialog>
            </div>
          }

        </div>
      </div>
    );
  }
}

WaiverDetails.propTypes = {
  waiver: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onDecisionClick: PropTypes.func.isRequired,
};
export default WaiverDetails;